<!-- <div style="display: flex; justify-content: end; align-items: center;">
    <span>
        <mat-icon aria-hidden="false" style="transform: translateY(2px);" aria-label="Example home icon">cancel</mat-icon>
    </span>
</div> -->
<div>
    <div id="buttonDiv" style="display: flex;justify-content: center;"></div>
    <div id="fb-button-container">
        <button id="fb-button" (click)="loginWithFacebook()">
            <img src="https://static.vecteezy.com/system/resources/thumbnails/018/930/698/small/facebook-logo-facebook-icon-transparent-free-png.png" alt="" srcset="" style="width: 35px; height: 35px;">
            Login with Facebook</button>
    </div>
</div>